import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function GoldeneHochzeit() {
  return (
    <MarketingPage
      eyebrow="Geschenk · Goldene Hochzeit"
      h1={
        <>
          Das Geschenk zur goldenen Hochzeit — fünf Jahrzehnte in einem{" "}
          <Swoosh>Buch</Swoosh>
        </>
      }
      lead={
        <>
          Fünfzig Jahre Ehe sind eine Bibliothek. Die wenigsten Paare
          erzählen ihren Kindern und Enkeln je, wie sie sich kennengelernt
          haben, was die ersten Jahre schwer gemacht hat, wann es gehalten
          und wann es gewackelt hat. <strong>
            Ein Geschenk zur goldenen Hochzeit
          </strong>{" "}
          kann diesem Halbjahrhundert eine Form geben — als gemeinsames,
          leinengebundenes Buch mit zwei Stimmen.
        </>
      }
      sections={[
        {
          h2: "Wie ein Paar gemeinsam erzählt",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Bei Paaren funktionieren zwei Wege gut:
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Getrennt.</strong> Beide rufen unabhängig voneinander
                an — er morgens, sie abends — und erzählen ihre Version.
                Konrad und Ida führen die Stränge im Manuskript zusammen. Das
                ergibt oft die interessantesten Bücher, weil sich an manchen
                Stellen Erinnerungen widersprechen.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Gemeinsam.</strong> Beide nehmen das Telefon auf
                Lautsprecher und erzählen zusammen. Eher selten gewählt, aber
                für Paare, die ohnehin alles gemeinsam machen, das natürliche
                Format.
              </p>
            </>
          ),
        },
        {
          h2: "Auch für andere Hochzeitstage",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Silberne Hochzeit (25 Jahre).</strong> Häufig wird
                Vitanara hier nicht für das Paar selbst geschenkt, sondern
                für die Eltern oder Schwiegereltern — weniger als Rückblick,
                mehr als Bestandsaufnahme.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Diamantene Hochzeit (60 Jahre).</strong> Bei
                diamantenen Hochzeiten geht Vitanara oft mit besonderer
                Dringlichkeit zur Sache — die Familien wissen, dass die Zeit
                endlich ist.
              </p>
              <p style={{ margin: 0 }}>
                <strong>Eiserne (65), gnadene (70), Kronjuwelen (75).</strong>{" "}
                Selten, aber jedes Mal das schönste Buch, das bei uns
                entsteht.
              </p>
            </>
          ),
        },
        {
          h2: "Was im Buch typischerweise steht",
          body: (
            <p style={{ margin: 0 }}>
              Erstes Kennenlernen, Hochzeit, die ersten Wohnungen, Geburt der
              Kinder, schwierige Jahre (fast jedes Paar hat welche),
              berufliche Wendepunkte, gemeinsame Reisen, Verlust von Eltern
              und Freunden, der Übergang in den Ruhestand, die Beziehung zu
              den Enkeln, was bleibt.
            </p>
          ),
        },
        {
          h2: "Wer dieses Geschenk macht",
          body: (
            <p style={{ margin: 0 }}>
              Meistens die erwachsenen Kinder, manchmal die Geschwister,
              gelegentlich Freunde der Familie. Bei goldenen Hochzeiten ist
              es üblich, dass mehrere Kinder das Geschenk gemeinsam stemmen —
              Vitanara ist ohnehin kein Geschenk, das sich gut teilen lässt,
              aber gut gemeinsam verschenken.
            </p>
          ),
        },
      ]}
      faqs={[
        {
          q: "Bekommt jedes Kind ein eigenes Exemplar?",
          a: "Eines ist enthalten, jedes weitere bestellbar. Bei großen Familien werden oft fünf bis zehn Exemplare gedruckt.",
        },
        {
          q: "Was, wenn die Eltern sich uneinig sind, wie etwas war?",
          a: "Genau das macht das Buch lesenswert. Konrad und Ida halten die zwei Versionen nebeneinander.",
        },
        {
          q: "Kann auch nur einer der beiden erzählen?",
          a: "Ja. Manche Paare entscheiden sich dafür. Das Buch funktioniert dann als Solo-Biografie mit einigen Passagen über den Partner.",
        },
      ]}
      crossLinks={[
        {
          to: "/geschenk-fuer-oma",
          label: "Geschenk für Oma",
          blurb:
            "Wenn nur Oma erzählen mag — eine Solo-Biografie ohne zweite Stimme.",
        },
        {
          to: "/geschenk-fuer-opa",
          label: "Geschenk für Opa",
          blurb: "Großväter, die am Telefon plötzlich erzählen.",
        },
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb: "Vom Anruf bis zum leinengebundenen Buch in zwölf Wochen.",
        },
      ]}
    />
  );
}
